import {getFunctions,httpsCallable} from 'firebase/functions';
// Operation failures must never interrupt the original upload/export error handling.
export async function reportOperationNotification({teamId=null,type,operationId,message}) {
 try {await httpsCallable(getFunctions(),'reportOwnOperationNotification')({teamId,type,operationId:String(operationId).slice(0,180),message:String(message).slice(0,500)});} catch(error) {console.warn('Could not save operation notification:',error);}
}
